<template lang="pug">
  Modal(v-bind="$attrs")
    div.flex.items-start.pr-8
      span(class="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-md bg-orange-200 text-orange-600")
        Icon(icon="megaphone", class="text-xl")
      div.ml-5
        h1.text-xl.font-semibold.text-heading For direct communications
        p.mt-1.text-paragraph Use the landing page in B2B or B2C marketing

    ShareLinkField.mt-8(:url="landingPageUrl", label="Landing page link")
</template>

<script>
import ShareLinkField from "@/components/ShareLinkField"

export default {
  components: {
    ShareLinkField
  },
  props: {
    landingPageUrl: {
      type: String,
      required: true
    }
  }
}
</script>
